import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=1539dae0&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1539dae0')) {
      api.createRecord('1539dae0', component.options)
    } else {
      api.reload('1539dae0', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=1539dae0&", function () {
      api.rerender('1539dae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/Content.vue"
export default component.exports